import React from "react";
import "react-quill/dist/quill.snow.css";
import { IoIosArrowRoundBack } from "react-icons/io";

type Props = {
  value: string;
  handleGoBack: () => void;
};
const PreviewBlog: React.FC<Props> = ({ value, handleGoBack }) => {
  return (
    <div className="w-full px-4 pt-2">
      <header className="flex items-center mb-4">
        <button
          onClick={handleGoBack}
          className="flex items-center justify-center cursor-pointer text-gray-600 text-2xl hover:bg-gray-200 rounded-full p-2"
        >
          <IoIosArrowRoundBack />
        </button>
        <h3 className="text-xl font-bold ml-2">Blog preview</h3>
      </header>
      <div dangerouslySetInnerHTML={{ __html: value }} className="px-12" />
    </div>
  );
};

export default PreviewBlog;
